module.exports = __webpack_public_path__ + "img/3-sapphire.411757b6.png";